export enum RolesType {
  TRANSACTION_READ = 'transaction.read',
  CARD_READ = 'card.read',
  MY_ACCOUNT = 'my-account',
  ACCOUNT_CREATE = 'account.create',
  ACCOUNT_READ = 'account.read',
  ACCOUNT_ADD_USER = 'account.addUser',
  FAVORED_CREATE = 'favored.create',
  PIX_MANAGE_KEYS = 'pix.manageKey',
  PIX_CREATE_TRANSACTION = 'pix.create_transaction',
  PIX_CONTROL_KEYS = 'pix.control_keys',
  TRANSACTION_CREATE = 'transaction.create',
  OFFLINE_ACCESS = 'offline_access',
  ACCOUNT_UPDATE = 'account.update',
  MANAGE_ACCOUNTS = 'manage-accounts',
  BALANCE_READ = 'balance.read',
  CARD_MANAGE = 'card.manage',
  CARD_BLOCK = 'card.block',
  CARD_UNBLOCK = 'card.unblock',
  CARD_CANCEL_REQUEST = 'card.cancel.request',
  CARD_DETAILS_READ = 'card.details.read',
  CARD_DUPLICATE_REQUEST = 'card.duplicate.request',
  CARD_PIN_RESET = 'card.pin.reset',
  CARD_TRACKING_READ = 'card.tracking.read',
  CARD_PASSWORD_VIEW = 'card.password.view',
  PAYABLE_READ = 'payable.read',
  PAYABLE_CREATE = 'payable.create',
  PAYABLE_APPROVER = 'payable.approve',
  PAYABLE_DETAILS = 'payable.details',
  MANAGE_GROUPS = 'manage_groups',
  MANAGE_NOT_EXITST = 'not-exist',
  EMPLOYEES_READ = 'employees.read',
  NEW_RECEIVABLE_READ = 'new.receivable.read',
  RECEIVABLE_READ = 'receivable.read',
  RECEIVABLE_CREATE_LINK = 'receivable-link.create',
  RECEIVABLE_CREATE_BILLET = 'receivable-billet.create',
  RECEIVABLE_CREATE_FILE = 'receivable-file.create',
  CONDOMINIUMS_PAGE = 'c slip.details',
  TRANSACTION_APPROVER = 'transaction.approver',
  EMPLOYEES_PAYMENT_APPROVE = 'employees.payment.approve',
  MANAGE_PIX_LIMIT = 'limite.pix',
  MANAGE_TEF_LIMIT = 'limite.tef',
  MANAGE_TED_LIMIT = 'limite.ted',
  PAYSLIP_READ = 'payslip.read',
  PAYSLIP_CREATE = 'payslip.create',
  PAYSLIP_DETAILS = 'payslip.details',
  MANAGE_BILLET_LIMIT = 'limite.billet',
  READ_PIX_LIMIT = 'limite.pix.read',
  READ_API_GATEWAY_PIX_LIMIT = 'limite.api_gateway_pix.read',
  MANAGE_API_GATEWAY_PIX_LIMIT = 'limite.api_gateway_pix.manage',
  READ_TEF_LIMIT = 'limite.tef.read',
  READ_TED_LIMIT = 'limite.ted.read',
  READ_BILLET_LIMIT = 'limite.billet.read',
  DEVICE_MANAGER = 'device.manager',
}

export default RolesType;
